import {
    CONVERSATIONAL_SESSION_KEY,
    MIJN_CONTACT_WEBCOMPONENT_KEY
} from '@klant/conversational-connector/klant-conversational-connector.constants';
import { ConversationalChatVisibility } from '@klant/conversational-connector/klant-conversational-connector.model'; // Adjust the import as needed

import { inject, Injectable } from '@angular/core';

import { ApPersistenceService } from '@ap/persistence';

import {
    CHAT_VISIBILITY_KEY,
    CONVERSATION_SESSION_DETAILS_KEY,
    ConversationSessionDetails,
    SEAMLY_ENVIRONMENT_CONFIG_KEY,
    SeamlyEnvironmentConfig
} from './session-storage.model';

@Injectable({ providedIn: 'root' })
export class SessionStorageService {
    private readonly apPersistenceService = inject(ApPersistenceService);

    public getChatVisibility(): ConversationalChatVisibility {
        const chatVisibility = this.apPersistenceService.getSession(CONVERSATIONAL_SESSION_KEY, CHAT_VISIBILITY_KEY);

        return chatVisibility ? chatVisibility : ConversationalChatVisibility.INVISIBLE;
    }

    public getOpenChatQueryParamValue(): boolean {
        const queryParams = this.apPersistenceService.getSession(MIJN_CONTACT_WEBCOMPONENT_KEY, 'queryParams');
        const openChatValue = queryParams?.['open_chat'];

        return openChatValue === 'true';
    }

    public getConversationSessionDetails(): ConversationSessionDetails {
        return this.apPersistenceService.getSession(CONVERSATIONAL_SESSION_KEY, CONVERSATION_SESSION_DETAILS_KEY);
    }

    public getSeamlyEnvironmentConfig(): SeamlyEnvironmentConfig {
        return this.apPersistenceService.getSession(CONVERSATIONAL_SESSION_KEY, SEAMLY_ENVIRONMENT_CONFIG_KEY);
    }

    public updateChatVisibility(chatVisibility: ConversationalChatVisibility): void {
        this.apPersistenceService.setSession(CONVERSATIONAL_SESSION_KEY, CHAT_VISIBILITY_KEY, chatVisibility);
    }

    public updateSeamlyEnvironmentConfig(seamlyEnvironmentConfig?: SeamlyEnvironmentConfig): void {
        this.apPersistenceService.setSession(CONVERSATIONAL_SESSION_KEY, SEAMLY_ENVIRONMENT_CONFIG_KEY, seamlyEnvironmentConfig);
    }

    public updateConversationSessionDetails(conversationSessionDetails?: ConversationSessionDetails): void {
        this.apPersistenceService.setSession(CONVERSATIONAL_SESSION_KEY, CONVERSATION_SESSION_DETAILS_KEY, conversationSessionDetails);
    }
}
